import React, { Component } from 'react';
import SashiDo from 'lib/SashiDo';
import GoogleTagManager from 'lib/GoogleTagManager';
import PhoneNumber from 'awesome-phonenumber';
import history from 'dashboard/history';
import 'whatwg-fetch';

import Button from 'components/Button/Button.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import ChromeDropdown from 'components/ChromeDropdown/ChromeDropdown.react';
import EmptyState from 'components/EmptyState/EmptyState.react';
import styles from './Billing.scss';
import settingsStyles from 'dashboard/Settings/Settings.scss';
import PreLoader from 'components/PreLoader/PreLoader.react';
import Fieldset from 'components/Fieldset/Fieldset.react';
import InputField from 'components/InputField/InputField.react';
import CreditCardInfo from './CreditCardInfo.react';
import Notification from 'components/Notification/Notification.react';
import { isoCountries, euCountries } from 'lib/Constants';

const Payment = require('payment');


// // TODO: @pivanov - when you have time please start from scratch when you have time
export default class CreditCard extends Component {
  constructor(props) {
    super();

    this.section = 'Billing';

    this.state = {
      loading: true,
      addCardSuccess: false,
      customerCard: {},
      customerInfo: {
        billing_address: {},
      },
      toolbarSubsection: '',
      country: '',
    };

    this.models = {
      name: {},
      email: {},
      address: {},
      phone: {},
      country: {},
      city: {},
      state: {},
      zip: {},
      company_name: {},
      vat_id: {},

      coupon: {},
      // cc_num: { },
      // expiry_date: { },
      // card_name: { },
      // cvv: { },
    };

    const billingAdress = props.currentCustomer.info.billing_address || {};

    this.models.name.value = billingAdress.first_name ? `${billingAdress.first_name} ${billingAdress.last_name}` : '';
    this.models.name.valid = !!this.models.name.value;

    this.models.email.value = billingAdress.email || props.currentUser.email;
    this.models.email.valid = !!this.models.email.value;

    this.models.address.value = billingAdress.line1;
    this.models.address.valid = !!this.models.address.value;

    const billingInfoPhone = billingAdress.phone;

    const originalPhone = billingInfoPhone && billingInfoPhone.startsWith('+')
      ? billingInfoPhone
      : `+${billingInfoPhone}`;

    const pn = new PhoneNumber(originalPhone);
    let phone = '+';

    if (pn.isValid()) {
      phone = pn.getNumber('international');
    }

    this.models.phone.value = phone;
    this.models.phone.valid = pn.isValid();

    this.models.country.value = billingAdress.country || '';
    this.models.country.valid = !!this.models.country.value;

    this.models.city.value = billingAdress.city;
    this.models.city.valid = !!this.models.city.value;

    this.models.state.value = billingAdress.state;

    this.models.zip.value = billingAdress.zip;
    this.models.zip.valid = !!this.models.zip.value;

    this.models.company_name.value = billingAdress.company;

    this.models.vat_id.value = props.currentCustomer.info.vat_number || props.currentCustomer.info.cf_company_reg_no;

    this.countries = Object.keys(isoCountries).map(value => ({ key: isoCountries[value], value }));

    this.onCloseClick = this.onCloseClick.bind(this);
  }

  componentDidMount() {
    if (this.props.view == 'addCard') {
      this.state.toolbarSubsection = 'Add Your Credit Card';
    }

    if (this.props.view == 'editCard') {
      this.state.toolbarSubsection = 'Edit Your Credit Card';
    }

    this.setState({
      ...this.state,
      allFieldsAreValid: this.check_valid(),
    });

    GoogleTagManager({
      data: {
        event: 'checkout',
        pageCategory: 'checkout',
      },
    });
  }

  onCloseClick() {
    const { addCardSuccess } = this.state;

    if (addCardSuccess) {
      window.location = '/billing/info'
    }

    // go to billing
    history.push('/billing/info');
  }


  onCountryChange(country) {
    this.models.country.value = country;
    this.models.country.valid = !!country;

    this.setState({
      allFieldsAreValid: this.check_valid(),
    });
  }

  // onCvvInputChange(e, value, validate) {
  //   const model = this.models.cvv;

  //   model.value = value.replace(/\D+/g, '').substr(0, 4);
  //   model.valid = validate(model.value);

  //   this.forceUpdate();
  // }


  // onExpirationInputChange(e, value, validate) {
  //   const model = this.models.expiry_date;

  //   value = value.replace(/[^\d\/\/]+/g, '').substr(0, 5);

  //   model.value = (value.match(/\d{1,2}/g) || []).join('/');
  //   if (value.length == 3 && value[2] == '/') {
  //     model.value += '/';
  //   }

  //   model.valid = validate(model.value);

  //   this.forceUpdate();
  // }


  onInputChange(field) {
    const model = this.models[field];


    return (e, value, validate) => {
      model.value = value;
      model.valid = validate(model.value);

      this.setState({
        allFieldsAreValid: this.check_valid(),
      });
    };
  }

  onPhoneChange = (e) => {
    const model = this.models["phone"]; // eslint-disable-line

    const { value } = e.target;
    const newValue = value.startsWith('+') ? value : `+${value}`;

    const pn = new PhoneNumber(newValue);

    model.value = pn.isValid() ? pn.getNumber('international') : newValue;
    model.valid = pn.isValid();

    this.setState({
      allFieldsAreValid: this.check_valid(),
    });
  }

  check_valid() {
    const fields = ['name', 'email', 'address', 'phone', 'country', 'city', 'zip'];

    for (const i of fields) {
      if (this.models[i].valid === false) {
        return false;
      }
    }

    return true;
  }

  handleKey(e) {
    const keyCode = e.keyCode || e.which;
    switch (keyCode) {
      case 27:
        this.onCloseClick(this);
        break;
    }
  }

  onSuccess = (payload) => {
    const { nonce } = payload;
    this.setState({ loading: true });

    const coupon_id = this.models.coupon.value;
    const name = this.models.name.value;
    const email = this.models.email.value;
    const address = this.models.address.value;
    const phone = this.models.phone.value;
    const country = this.models.country.value;
    const city = this.models.city.value;
    const state = this.models.state.value;
    const zip = this.models.zip.value;
    const company_name = this.models.company_name.value;
    const vat_id = this.models.vat_id.value;
    // const cc_num = this.models.cc_num.value;
    // const expiry_date = this.models.expiry_date.value;
    // const card_name = this.models.card_name.value;
    // const cvv = this.models.cvv.value;

    return fetch('https://api-cloudstrap-ipapi.scalabl.cloud/').then((response) => {
      response.json().then((data) => {
        SashiDo.setUserBillingInfo({
          username: this.props.currentUser.email,
          coupon_id,
          name,
          email,
          address,
          phone,
          country,
          city,
          state,
          zip,
          company_name,
          vat_id,
          // cc_num,
          // expiry_date,
          // card_name,
          // cvv,
          ip: data.ip,
          payment_intent: nonce,
        })
          .then(({ success, error }) => {
            if (success) {
              GoogleTagManager({
                data: {
                  event: 'purchase',
                  pageCategory: 'confirmation',
                  billingCountry: country,
                  acountType: company_name ? 'company' : 'personal',
                },
              });

              SashiDo.activityTrack({
                type: 'update_billing',
              }).then(() => {
                window.location = '/billing/info';
              });
            }

            if (error) {
              this.setState({ loading: false, addCardSuccess: true, error });
            }
          });
      });
    })
      .catch((error) => {
        this.setState({ loading: false, addCardSuccess: true, error });
      });
  }

  onError = (error) => {
    this.setState({ loading: false, addCardSuccess: true, error });
  }

  try_again() {
    this.setState({ loading: false, addCardSuccess: false, error: null });
    setTimeout(() => this.forceUpdate(), 0); // ... for the country to show correct ... T_T
  }

  handleLoading = (loading) => {
    this.setState({
      loading,
    });
  }

  updateCreditCard() {
    this.setState((state) => {
      return {
        customerCard: { ...state.customerCard, status: '' },
        updateCreditCardCloseButton: true,
      };
    });
  }

  render() {
    const classes = [settingsStyles.settings_page, settingsStyles.default];

    const content = (
      <Fieldset
        legend="Payment Method"
        description="Enter Your Payment Information">
        <div className={settingsStyles.settingsBox}>
          <div className={[styles.box, styles.table, styles.billingInfo].join(' ')}>
            {
              this.props.view == 'addCard'
                ?
                <div className={styles.cardCoupon}>
                  <div className={styles.tableRow}>
                    <div className={styles.col1}>If you have a Promo Code, please enter it below to receive your credit.</div>
                  </div>

                  <InputField label="Enter Promo Code" onChange={this.onInputChange('coupon')} value={this.models.coupon.value} />
                </div>
                : null
            }

            <div className={styles.tableRow}>
              <div className={styles.col1}>Billing Info</div>
            </div>

            <div className={[styles.box, styles.pa, styles.rows].join(' ')}>

              <div className={styles.row}>
                <InputField label="Full Name" require valid={this.models.name.valid} validate={[v_require]} onChange={this.onInputChange('name')} value={this.models.name.value} />
                <InputField label="E-mail" require valid={this.models.email.valid} validate={[v_require]} onChange={this.onInputChange('email')} value={this.models.email.value} />
              </div>

              <div className={styles.row}>
                <InputField label="Address" require validate={[v_require]} valid={this.models.address.valid} onChange={this.onInputChange('address')} value={this.models.address.value} />
                <InputField label="Phone" require validate={[v_require]} valid={this.models.phone.valid} onChange={e => this.onPhoneChange(e)} value={this.models.phone.value} />
              </div>

              <div className={styles.row}>
                <ChromeDropdown
                  color="blue"
                  value={this.models.country.value}
                  className="select"
                  require
                  valid
                  label="Country"
                  options={this.countries}
                  onChange={this.onCountryChange.bind(this)} />

                <InputField label="City" require valid={this.models.city.valid} validate={[v_require]} onChange={this.onInputChange('city')} value={this.models.city.value} />
              </div>

              <div className={styles.row}>
                <InputField label="State" valid={this.models.state.valid} onChange={this.onInputChange('state')} value={this.models.state.value} />
                <InputField label="ZIP" require valid={this.models.zip.valid} validate={[v_require]} onChange={this.onInputChange('zip')} value={this.models.zip.value} />
                {/* <div className={[styles.inputHolder, styles.invalid].join(' ')}>
                  <label htmlFor="cc-postal-code">Postal Code</label>
                  <div className={styles.input} id="cc-postal-code" />
                </div> */}
              </div>

              <div className={styles.row}>
                <InputField label="Company Name" require={false} valid={this.models.company_name.valid} onChange={this.onInputChange('company_name')} value={this.models.company_name.value} />
                <InputField label="VAT ID / Company Reg. #" require={false} pre={euCountries.includes(this.models.country.value) ? this.models.country.value : null} valid={this.models.vat_id.valid} onChange={this.onInputChange('vat_id')} value={this.models.vat_id.value} />
              </div>
            </div>

            <div className={[styles.tableRow, styles.creditCard].join(' ')}>
              <div className={styles.col1}>Credit Card</div>
            </div>


            <CreditCardInfo
              allFieldsAreValid={this.state.allFieldsAreValid}
              currentUser={this.props.currentUser}
              userInfo={this.models}
              handleLoading={this.handleLoading}
              onSuccess={this.onSuccess}
              onError={this.onError}
            />
          </div>
        </div>
      </Fieldset>
    );

    let result_page = null;
    if (this.state.error) {
      result_page = (
        <EmptyState>
          <div className={settingsStyles.emptyState}>
            <div className={settingsStyles.title}>There was an error!</div>
            <div className={settingsStyles.description}>{this.state.error}</div>
            <div className={settingsStyles.description}>Please try again and contact us if the error still exist.</div>
            <div className={settingsStyles.action}>
              <Button color="green" value="Try Again" onClick={this.try_again.bind(this)} />
            </div>
          </div>
        </EmptyState>
      );
    }
    else {
      result_page = (
        <EmptyState>
          <div className={settingsStyles.emptyState}>
            <div className={settingsStyles.title}>Success!</div>
            <div className={settingsStyles.description}>
              {
                this.state.customerCard.status === 'valid'
                  ? 'Your billing info was successfully updated.'
                  : 'Your card was successfully updated.'
              }
            </div>
            <div className={[settingsStyles.action, settingsStyles.groupButtons].join(' ')}>
              <Button color="green" value="Create New App" size="big" onClick={() => { history.push('/create'); }} />
            </div>
          </div>
        </EmptyState>
      );
    }

    return (
      <div className={classes.join(' ')}>
        <Toolbar section={this.section} subsection={this.state.toolbarSubsection}>
          <Button value="Go Back" onClick={this.onCloseClick.bind(this)} />
        </Toolbar>
        <PreLoader loading={this.state.loading}>
          <div className={settingsStyles.holder}>
            <Notification note={this.state.inviteSuccess} close />
            {this.state.addCardSuccess ? result_page : content}
          </div>
        </PreLoader>
      </div>
    );
  }
}

function v_require(value) {
  if (value != '') {
    return true;
  }

  return false;
}

function v_card_cvc(value) {
  return Payment.fns.validateCardCVC(value);
}

function v_card_expiry(value) {
  return Payment.fns.validateCardExpiry.apply(null, value.split('/'));
}
